"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOfficeHours = isOfficeHours;
exports.formatMoney = formatMoney;
exports.youtubeLoader = youtubeLoader;
function isOfficeHours() {
    // Monday to Friday, 9am to 5.30pm
    const now = new Date();
    const day = now.getDay();
    const hour = now.getHours();
    const minute = now.getMinutes();
    return (day > 0 && day < 6) && ((hour >= 9 && hour < 17) || (hour === 17 && minute < 30));
}
function formatMoney(amount) {
    return amount.toLocaleString('nl-NL', {
        style: 'currency',
        currency: 'EUR',
        maximumFractionDigits: 2
    })
        .replace(',00', ',-');
}
function youtubeLoader() {
    return {
        started: false,
        startVideo() {
            this.started = true;
        }
    };
}
